import { gql } from '@apollo/client' ;

export default gql`
  fragment episodeOfCare on EpisodeOfCare {
    id
    status
  }
`;
